import { render, staticRenderFns } from "./TransactionsWithPagination.vue?vue&type=template&id=42f15ba6&"
import script from "./TransactionsWithPagination.vue?vue&type=script&lang=js&"
export * from "./TransactionsWithPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports